import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateCaveatTypeActions } from "store/ducks/settings/caveat-types";

export function* updateCaveatTypeRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/indent-caveat-types/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateCaveatTypeActions.success(data));
    notify("success", "Tipo de ressalva atualizado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateCaveatTypeActions.failure(errorMessage));
  }
}
